import { useState, useEffect } from 'react';
import insertUrlParams from '../utils/insertUrlParams';
import getUrlParam from '../utils/getUrlParam';

export default function useStateSchema({
  handleLocationIDsChange,
  handleRiverIDChange,
  operationalStates
}) {
  const [stateSchema, setstateSchema] = useState('');

  useEffect(() => {
    if (Object.keys(operationalStates).length > 0) {
      let state = getUrlParam('state') || '';
      if (!Object.keys(operationalStates).includes(state)) {
        state = '';
        insertUrlParams({ state: '' });
      } else {
        setstateSchema(state);
      }
    }
  }, [operationalStates]);

  const handleStateSchemaChange = (newStateSchema) => {
    handleRiverIDChange(undefined);
    handleLocationIDsChange(undefined);
    insertUrlParams({ state: newStateSchema });
    setstateSchema(newStateSchema);
  };

  return { stateSchema, handleStateSchemaChange };
}
